import { useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";
import { FileText, Loader2 } from "lucide-react";
import TermsContent from "./TermsContent";

/** The acceptance window: the whole Terms of Use to scroll through, then « J'accepte » or
 * « Je refuse ». « J'accepte » only becomes available once the text was read to the end. */
export default function TermsModal({ intro, refuseLabel = "Je refuse", busy = false, onAccept, onRefuse }) {
  const box = useRef(null);
  const [readToEnd, setReadToEnd] = useState(false);

  const check = () => {
    const el = box.current;
    if (el && el.scrollTop + el.clientHeight >= el.scrollHeight - 24) setReadToEnd(true);
  };
  useEffect(() => { check(); }, []); // a tall screen may show it all at once

  return createPortal(
    <div className="fixed inset-0 z-[95] bg-black/90 backdrop-blur-md grid place-items-center p-3 sm:p-4" data-testid="terms-modal">
      <div className="w-full max-w-2xl max-h-[92vh] flex flex-col bg-zinc-950 border border-white/10 rounded-3xl overflow-hidden">
        <div className="p-5 border-b border-white/10 flex items-start gap-3">
          <div className="w-10 h-10 shrink-0 grid place-items-center rounded-xl bg-gradient-to-br from-[#FF0050] to-[#8A2BE2]">
            <FileText className="w-5 h-5 text-white" />
          </div>
          <div>
            <h3 className="text-xl font-black font-display text-white">Conditions d'utilisation</h3>
            <p className="text-sm text-zinc-400 mt-0.5">{intro}</p>
          </div>
        </div>
        <div ref={box} onScroll={check} className="flex-1 overflow-y-auto px-5 py-4" data-testid="terms-modal-text">
          <TermsContent inWindow />
        </div>
        <div className="p-4 border-t border-white/10 space-y-2">
          {!readToEnd && (
            <p className="text-xs text-amber-300 text-center">Fais défiler le texte jusqu'en bas pour pouvoir accepter.</p>
          )}
          <div className="flex gap-2">
            <button type="button" onClick={onRefuse} disabled={busy} className="btn-secondary flex-1" data-testid="terms-refuse">
              {refuseLabel}
            </button>
            <button type="button" onClick={onAccept} disabled={busy || !readToEnd}
              className="btn-primary flex-1 inline-flex items-center justify-center gap-2 disabled:opacity-50" data-testid="terms-accept">
              {busy && <Loader2 className="w-4 h-4 animate-spin" />} J'accepte
            </button>
          </div>
        </div>
      </div>
    </div>,
    document.body
  );
}
